// analytics.js — Google Analytics 4. Off unless REACT_APP_GA_MEASUREMENT_ID is
// set at build time (frontend/.env.production), and never in automated
// browsers (the pre-renderer and browser tests), so they don't count as visits.
//
// Consent Mode defaults are set by the inline script at the top of
// public/index.html: denied in the EEA, UK and Switzerland until the AdSense
// consent message (Google's CMP) updates them, granted elsewhere.
//
// Page views are sent by trackPageView() on every route change, including the
// first, so GA's own "page changes based on browser history events" setting
// must be off in the web stream's enhanced measurement (it would double count).

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const enabled = Boolean(GA_ID) && typeof window !== "undefined" && !navigator.webdriver;

function gtag() {
  // Defined by public/index.html; fall back so a missing snippet can't throw.
  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
  window.gtag(...arguments);
}

export function initAnalytics() {
  if (!enabled) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView() {
  if (!enabled) return;
  // React inserts the page's <title> ahead of index.html's fallback, so
  // document.title is the page's own title, as in the browser tab.
  gtag("event", "page_view", { page_location: window.location.href, page_title: document.title });
}

export function trackEvent(name, params) {
  if (!enabled) return;
  gtag("event", name, params);
}
